import { createI18n } from "vue-i18n";
import zhJson from './zh.json';
import enJson from './en.json';
import thJson from './th.json';
import { getCookie, getUrlKey, setCookie } from '@/utils/common';
import vantVn from "vant/lib/locale/lang/vi-VN";
import vantTh from "vant/lib/locale/lang/th-TH";
import vantEn from "vant/lib/locale/lang/en-US";
import vantZh from "vant/lib/locale/lang/zh-CN";
import vantHK from "vant/lib/locale/lang/zh-HK";
import { Locale } from "vant";

const messages = {
  en: enJson,
  th: thJson,
  zh: zhJson
};

const i18n = createI18n({
  locale: 'en', // 设置默认语言
  messages,
});

let lang = getUrlKey("lang", window.location.href);

if (lang) {
  if (lang == "zh_CN" || lang == "zh") {
    lang = "zh-CN";
  } else if (lang == "zh_HK") {
    lang = "zh-HK";
  } else if (lang == "tc") {
    lang = "zh-HK";
  }
}
if (lang) {
  if (
    lang !== "en" &&
    lang !== "zh-CN" &&
    lang !== "th-TH"
  ) {
    console.log(lang);
    lang = transformIntlAppLang(lang);
  }
  setCookie("lang", lang);
}

// 国际app很多不同国家语言，没有转化处理的统一设置为en
function transformIntlAppLang(lang) {
  if (lang === "zh_CN" || lang === "zh-CN") {
    return "zh-CN";
  }
  if (lang === "zh-HK" || lang === "zh_HK") {
    return "zh-HK";
  }
  return "en";
}


function getCurLangCode() {
  return i18n.global.locale;
}

const locale = lang || getCookie("lang") || "zh-CN";

vantLocales(locale);
// 更新vant组件库本身的语言变化，支持国际化
function vantLocales(lang) {
  if (lang === "en") {
    Locale.use("en-US", vantEn);
  } else if (lang === "zh-CN") {
    Locale.use("zh-CN", vantZh);
  } else if (lang === "th-TH") {
    Locale.use("th-TH", vantTh);
  }
  i18n.global.locale = lang;
}

export { getCurLangCode, i18n, vantLocales };
